// extracted by mini-css-extract-plugin
module.exports = {"chat-channels-list":"ConversationsList_chat-channels-list__228lf"};